import { useAppSelector } from '@store';
import { CorporateRightSideContentTypes } from './types';
import cn from '../partial/info-right-side/info-right-side.module.css';

const CorporateRightSideContent = ({
  name,
  registrationNumber,
  owner,
  sic,
  countryOfIncorporated,
}: CorporateRightSideContentTypes): React.JSX.Element => {
  const { countries } = useAppSelector((state) => state.customersDictionaries);

  return (
    <>
      <div className={cn.nameWrapper}>
        <div className={cn.nameWrapperTitle}>Corporate customer</div>
        <div className={cn.nameWrapperValue}>{name}</div>
      </div>
      <div className={cn.nameWrapper}>
        <div className={cn.nameWrapperTitle}>Registration number</div>
        <div className={cn.wrapperValue}>{registrationNumber}</div>
      </div>
      <div className={cn.nameWrapper}>
        <div className={cn.nameWrapperTitle}>Owner</div>
        <div className={cn.wrapperValue}>
          {owner
            ? `${owner?.user?.profile?.firstName} ${owner?.user?.profile?.lastName}`
            : '-'}
        </div>
      </div>
      <div className={cn.nameWrapper}>
        <div className={cn.nameWrapperTitle}>SIC</div>
        <div className={cn.wrapperValue}>{sic}</div>
      </div>
      <div className={cn.nameWrapper}>
        <div className={cn.nameWrapperTitle}>Country of Incorporated</div>
        <div className={cn.wrapperValue}>
          {
            countries?.find((item) => item.value === countryOfIncorporated)
              ?.name
          }
        </div>
      </div>
    </>
  );
};

export default CorporateRightSideContent;
